module.exports = __webpack_public_path__ + "static/img/3-role.ee59acb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/3-role.png
// module id = 5wyY
// module chunks = 1